import env                      from "../../envVariables";
import { ohifActionsConstants } from "../constants";

const initialState = {
  documentKOSTitleTrigger: "",
  
  ohifAuthUsername   : env.REACT_APP_OHIF_AUTH_USERNAME,
  ohifAuthUsernameArg: env.REACT_APP_OHIF_AUTH_USERNAME_ARG_NAME,
  ohifAuthPasswd     : env.REACT_APP_OHIF_AUTH_PASSWD,
  ohifAuthPasswdArg  : env.REACT_APP_OHIF_AUTH_PASSWD_ARG_NAME,
  ohifAuthUrl        : env.REACT_APP_OHIF_AUTH_URL,
  
  ohifKosViewerRootUrl        : env.REACT_APP_OHIF_VIEWER_ROOT_URL,
  ohifKosStudyPath            : env.REACT_APP_OHIF_VIEWER_STUDY_PATH,
  ohifKosSeriesPath           : env.REACT_APP_OHIF_VIEWER_SERIES_PATH,
  ohifKosPSCTokenBearer       : Number(env.REACT_APP_OHIF_VIEWER_PSC_TOKEN_BEARER) === 1,
  ohifKosAuthTokenBearer      : Number(env.REACT_APP_OHIF_VIEWER_AUTH_TOKEN_BEARER) === 1,
  ohifKosStructIdNatHeaderName: env.REACT_APP_OHIF_VIEWER_STRUCT_ID_NAT_HEADER_NAME,
  ohifKosSessionIdHeaderName  : env.REACT_APP_OHIF_VIEWER_SESSIONID_HEADER_NAME,
  ohifKosInBody               : Number(env.REACT_APP_OHIF_VIEWER_KOS_IN_BODY) === 1,
  ohifKosRequestParams        : env.REACT_APP_OHIF_VIEWER_REQUEST_PARAMS,
  
  // PACS
  ohifGetPacsListMethod               : env.REACT_APP_OHIF_GET_PACS_LIST_METHOD,
  ohifGetPacsListRootUrl              : env.REACT_APP_OHIF_GET_PACS_LIST_ROOT_URL,
  ohifGetPacsListPSCTokenBearer       : Number(env.REACT_APP_OHIF_GET_PACS_LIST_PSC_TOKEN_BEARER) === 1,
  ohifGetPacsListAuthTokenBearer      : Number(env.REACT_APP_OHIF_GET_PACS_LIST_AUTH_TOKEN_BEARER) === 1,
  ohifGetPacsListStructIdNatHeaderName: env.REACT_APP_OHIF_GET_PACS_LIST_STRUCT_ID_NAT_HEADER_NAME,
  ohifGetPacsListSessionIdHeaderName  : env.REACT_APP_OHIF_GET_PACS_LIST_SESSIONID_HEADER_NAME,
  ohifGetPacsListRequestParams        : env.REACT_APP_OHIF_GET_PACS_LIST_REQUEST_PARAMS,
  ohifGetPacsListArrayField           : env.REACT_APP_OHIF_GET_PACS_LIST_ARRAY_FIELD,
  ohifGetPacsListLabelField           : env.REACT_APP_OHIF_GET_PACS_LIST_LABEL_FIELD,
  ohifGetPacsListIdField              : env.REACT_APP_OHIF_GET_PACS_LIST_ID_FIELD,
  
  ohifTransferToPacsRootUrl              : env.REACT_APP_OHIF_TRANSFER_TO_PACS_ROOT_URL,
  ohifTransferToPacsStudyPath            : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STUDY_PATH,
  ohifTransferToPacsSeriesPath           : env.REACT_APP_OHIF_TRANSFER_TO_PACS_SERIES_PATH,
  ohifTransferToPacsPSCTokenBearer       : Number(env.REACT_APP_OHIF_TRANSFER_TO_PACS_PSC_TOKEN_BEARER) === 1,
  ohifTransferToPacsAuthTokenBearer      : Number(env.REACT_APP_OHIF_TRANSFER_TO_PACS_AUTH_TOKEN_BEARER) === 1,
  ohifTransferToPacsSessionIdHeaderName  : env.REACT_APP_OHIF_TRANSFER_TO_PACS_SESSIONID_HEADER_NAME,
  ohifTransferToPacsStructIdNatHeaderName: env.REACT_APP_OHIF_TRANSFER_TO_PACS_STRUCT_ID_NAT_HEADER_NAME,
  ohifTransferToPacsPacsIdHeaderName     : env.REACT_APP_OHIF_TRANSFER_TO_PACS_PACSID_HEADER_NAME,
  ohifTransferToPacsRequestParams        : env.REACT_APP_OHIF_TRANSFER_TO_PACS_REQUEST_PARAMS,
  ohifTransferToPacsResultTransferIdName : env.REACT_APP_OHIF_TRANSFER_TO_PACS_RESULT_TRANSFERID_NAME,
  
  ohifTransferToPacsStatusMethod               : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_METHOD,
  ohifTransferToPacsStatusRootUrl              : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_ROOT_URL,
  ohifTransferToPacsStatusPSCTokenBearer       : Number(env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_PSC_TOKEN_BEARER) === 1,
  ohifTransferToPacsStatusAuthTokenBearer      : Number(env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_AUTH_TOKEN_BEARER) === 1,
  ohifTransferToPacsStatusSessionIdHeaderName  : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_SESSIONID_HEADER_NAME,
  ohifTransferToPacsStatusStructIdNatHeaderName: env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_STRUCT_ID_NAT_HEADER_NAME,
  ohifTransferToPacsStatusPacsIdHeaderName     : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_PACSID_HEADER_NAME,
  ohifTransferToPacsStatusTransferIdArgName    : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_TRANSFERID_ARG_NAME,
  ohifTransferToPacsStatusRequestParams        : env.REACT_APP_OHIF_TRANSFER_TO_PACS_STATUS_REQUEST_PARAMS,
  
  defaultPacsId: undefined,
  ohifAuthToken: undefined,
  ohifSessionId: undefined,
  
  ohifKosViewerDebugUrl: `https://ohifviewer.icanopee.net/viewer?StudyInstanceUIDs=1.3.6.1.4.1.14519.5.2.1.1706.8374.643249677828306008300337414785&initialSeriesInstanceUID=1.3.6.1.4.1.14519.5.2.1.1706.8374.134469846969371865041508269759`
};

export function ohifConfig (state = initialState, action) {
  switch (action.type) {
    case ohifActionsConstants.RESET_OHIF_CONFIG:
      return initialState;
    case ohifActionsConstants.SET_OHIF_CONFIG:
      return { ...state, [action.key]: action.value };
    
    default:
      return state;
  }
}
